const Close = props => (
    <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g clipPath="url(#a)">
            <path
                d="M10 0a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm3.36 12.3a.75.75 0 0 1-1.06 1.06l-2.3-2.3-2.3 2.3a.73.73 0 0 1-.53.22.74.74 0 0 1-.53-.22.75.75 0 0 1 0-1.06l2.3-2.3-2.3-2.3A.75.75 0 0 1 7.7 6.64l2.3 2.3 2.3-2.3a.75.75 0 0 1 1.06 1.06l-2.3 2.3 2.3 2.3Z"
                fill={props.color}
            />
        </g>
        <defs>
            <clipPath id="a">
                <path fill="#fff" d="M0 0h20v20H0z" />
            </clipPath>
        </defs>
    </svg>
)

export default Close
